// extracted by mini-css-extract-plugin
export default {"heading":"GS","container":"HS","product_section_row":"IS","carousel":"JS","carouselwide":"KS","carouselwrapper":"LS","blockwrapper":"MS","product_carousel_row":"NS","headingnarrow":"OS","title":"PS"};
    if(module.hot) {
      // 1743628927996
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  